const norm = (v: string | number) => String(v);

// 1) read only the selected values from the FULL cached list
export function selectionMapFromCachedList(
  cachedList: any[]
): Record<string, Set<string>> {
  const map: Record<string, Set<string>> = {};
  for (const group of cachedList || []) {
    const gKey = norm(group?.value);
    if (!gKey) continue;

    if (Array.isArray(group?.children) && group.children.length) {
      const set = new Set<string>();
      for (const ch of group.children) {
        if (ch?.isSelected) set.add(norm(ch.value));
      }
      if (set.size) map[gKey] = set;
    } else if (group?.isSelected) {
      map[gKey] = new Set(["__SELF__"]); // support leaf groups with no children
    }
  }
  return map;
}

// 2) apply saved selections onto the fresh structure (titles/structure from fresh)
export function applySelectionMapToFresh(
  freshList: any[],
  saved: Record<string, Set<string>>
) {
  return (freshList || []).map((group) => {
    const gKey = norm(group.value);
    const savedSet = saved[gKey];
    const newGroup = { ...group };
    if (Array.isArray(group.children) && group.children.length) {
      newGroup.children = group.children.map((ch) => ({
        ...ch,
        isSelected: !!savedSet?.has(norm(ch.value)),
      }));
      newGroup.isSelected = newGroup.children.some((c) => c.isSelected);
    } else {
      newGroup.isSelected = !!savedSet?.has("__SELF__");
    }
    return newGroup;
  });
}
